export default "__VITE_PUBLIC_ASSET__4fc6ff3f__"